/**
 * Asynchronously loads the component for CRMSettingsComponent
 */

import { lazyLoad } from 'utils/loadable';

export const CRMSettingsComponent = lazyLoad(
  () => import('./index'),
  module => module.CRMSettingsComponent,
);
